#import "../fragments/account-page-fragment.graphql"

mutation UpdateAccountCustomFieldValue($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
        account {
            ...AccountPageFragment
        }
    }
}
